const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function extractPrivateFileId(src) {
  if (!src) return null;

  const downloadMatch = String(src).match(
    /\/file\/download\/([0-9a-f-]{36})/i
  );
  if (downloadMatch) return downloadMatch[1];

  if (UUID_PATTERN.test(src)) return src;

  return null;
}

export function isPrivateFileSource(src) {
  return extractPrivateFileId(src) !== null;
}
